import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import checkIcon from '../../icons/check.svg';
import clearIcon from '../../icons/clear.svg';
import SVGIcon from '../SVGIcon';
import styles from './ToggleControl.module.scss';

const propTypes = {
  error: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
};

const defaultProps = {
  error: null,
  label: null,
  disabled: false,
};

const ToggleControl = ({ error, label, disabled, ...inputProps }) => (
  <label className={classNames(styles.toggle, { [styles.error]: error })}>
    {label && <div className={styles.label}>{label}</div>}
    <input className={styles.input} disabled={disabled} {...inputProps} />
    <div
      className={classNames(styles.track, {
        [styles.disabled]: disabled,
      })}
    >
      <div className={styles.knob}>
        <SVGIcon className={styles.onIcon} size={10}>
          {checkIcon}
        </SVGIcon>
        <SVGIcon className={styles.offIcon} size={10}>
          {clearIcon}
        </SVGIcon>
      </div>
    </div>
  </label>
);

ToggleControl.propTypes = propTypes;
ToggleControl.defaultProps = defaultProps;

export default ToggleControl;
